import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as jsPDF from 'jspdf';
import { Subject, Subscription } from 'rxjs';
import { PacienteService } from 'src/app/services/licitacao/paciente.service';
import { AtribuicoesService } from 'src/app/services/rh/atribuicoes.service';
import { GerarPdfOsService } from 'src/app/services/utils/gerar-pdf-os.service';
import { AuthService } from 'src/app/services/vos/auth.service';
import { ReportsService } from 'src/app/services/vos/reports.service';
import { Funcoes } from 'src/app/shared/funcoes';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-relatorio-prestador',
  templateUrl: './relatorio-prestador.component.html',
  styleUrls: ['./relatorio-prestador.component.css']
})
export class RelatorioPrestadorComponent implements OnInit {
  data: any = [];
  logo: any = [];
  usuario: any
  data$ = new Subject<any>();
  arrayPaciente: Array<any> = [];
  loading: boolean = true;
  inscricao: Subscription

  constructor(
    private authService: AuthService,
    private reportsService: ReportsService,
    private pacienteService: PacienteService,
    private pdfService: GerarPdfOsService
  ) { }

  ngOnInit(): void {
    // this.getRelatorios()
    this.buscaPacientes()
  }
  pegaUsuario() {
    this.usuario = JSON.parse(this.authService.getUserLoggedIn());
    if (this.usuario?.user.pessoa.profissional) this.logo = this.usuario.user.pessoa.profissional.empresa
    if (this.usuario?.user.pessoa.cliente) this.logo = this.usuario.user.pessoa.cliente.empresa
    if (this.usuario?.user.pessoa.responsavel) this.logo = this.usuario.user.pessoa.responsavel.empresa
  }
  buscaPacientes() {
    this.inscricao = this.pacienteService.pegarListaDePacientesPorIdEmpresa().subscribe(res => {
      this.arrayPaciente = res;
      this.data$.next(this.arrayPaciente);
      this.loading = false;
    });
  }
  // getRelatorios() {
  //   this.inscricao = this.reportsService.getRelatorios().subscribe(res => {
  //     console.log(res)
  //     this.data = res
  //   })
  // }

  gerarPdf(item) {
    var doc = new jsPDF();
    let margin = 50;
    let pdf_pages = doc.internal.pages;

    //PACIENTE
    (doc as any).autoTable({
      head: [[{ colSpan: 2, content: 'Dados do Paciente' }]],
      body: [
        [`Paciente: ${item.paciente?.pessoa?.nome}`, `Nasc.: ${new DatePipe('pt-BR').transform(item.paciente?.pessoa?.nascimento, 'dd/MM/yyyy')}`,
        `Genero: ${item.paciente?.sexo}`],
        [`CPF: ${item.paciente?.pessoa?.cpfcnpj}`, `RG: ${item.paciente?.pessoa?.rgie}`, 'Tel: '],
      ],
      startY: 35,
      theme: 'grid',
      tableWidth: 'auto',
    });

    // //MAT/MED/Equi
    // let itensProdutoOrcamento = [];
    // for (let i = 0; i < item.orcamento.produtos.length; i++) {
    //   itensProdutoOrcamento.push([
    //     item.orcamento.produtos[i].produto.descricao ? item.orcamento.produtos[i].produto.descricao : item.orcamento.produtos[i].produto.descricao,
    //     item.orcamento.produtos[i].quantidade,
    //     new Funcoes().formatarMoeda(
    //       parseFloat(item.orcamento.produtos[i].valorunitario).toFixed(2)
    //     ),
    //     new Funcoes().formatarMoeda(
    //       parseFloat(item.orcamento.produtos[i].subtotal).toFixed(2)
    //     ),
    //   ]);
    // }
    // (doc as any).autoTable({
    //   head: [
    //     [{ colSpan: 4, content: 'Produtos: ' }],
    //     [
    //       ['Descrição do Poduto'],
    //       ['Quantidade'],
    //       ['Valor Unitário'],
    //       'Valor Total',
    //     ],
    //   ],
    //   body: itensProdutoOrcamento,
    //   startY: doc.lastAutoTable.finalY += 5,
    //   theme: 'grid',
    //   tableWidth: 'auto',
    // });

    // (doc as any).autoTable({
    //   body: [
    //     [
    //       ['Total:'],
    //       [`${new Funcoes().formatarMoeda(item?.orcamento?.produtos.reduce((accumulator, currentValue) => accumulator + currentValue.subtotal, 0).toFixed(2))}`],
    //     ],
    //   ],
    //   startY: doc.lastAutoTable.finalY += 5,
    //   theme: 'grid',
    //   tableWidth: 'auto',
    // });


    // for (let i = 1; i < pdf_pages.length; i++) {
    //   doc.setPage(i)
    //   this.pdfService.headerFooterPage(doc, i, `Venda`, this.usuario, this.logo)
    // }
    doc.save('Venda' + item?.paciente?.pessoa?.nome + '.pdf');
  }
}
